import type { Island } from '@rta/rta-blueprint-library';

/**
 * Blueprint island order — delegates to the shared library connection-chain ordering
 * (`islands.orderedChildren`) so the blueprint's A/B/C labels and page order match the
 * overhead view and the pricing/estimate order. Filters to the requested subset while
 * preserving that canonical order; falls back to a left-to-right coordinate sort only
 * when the islands collection can't be reached.
 */
export const getSortedIslands = (islands: Array<Island>): Array<Island> => {
	if (islands.length <= 1) return [...islands];

	const collection = islands[0]?.refMap?.islands ?? null;
	if (!collection) return [...islands].sort((a, b) => a.origin.x - b.origin.x);

	const requested = new Set(islands.map((island) => island.id));
	return collection.orderedChildren.filter((island) => requested.has(island.id));
};
